import { MemberTypeDetailPage } from '@/features/member-type/pages/MemberTypeDetailPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/member-type/$id/detail')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["member_type.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: MemberTypeDetailPage,
})
